import { SET_NYSERDA_IS_VISIBLE } from './constants';

export const setNYSERDAIsVisible = isVisible => ({
    type: SET_NYSERDA_IS_VISIBLE,
    isVisible,
});



// WEBPACK FOOTER //
// ./src/containers/Inputs/NYSERDA/actions.js